import { SummarySectionWrapper } from '../shared_styled_components';
import { CallNotes } from './legacy_notes/notes';

interface NotesProps {
    readOnly?: boolean;
}
export const Notes = ({ readOnly }: NotesProps): JSX.Element => {
    return (
        <SummarySectionWrapper>
            <CallNotes readOnly={readOnly} />
        </SummarySectionWrapper>
    );
};
